module.exports = __webpack_public_path__ + "static/MaskGroup-2-3d0dc567e31fc44dbd50bdf2b9624e77.jpg";